import script from "./SkillsSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./SkillsSection.vue?vue&type=script&lang=ts&setup=true"

import "./SkillsSection.vue?vue&type=style&index=0&id=159cda59&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-159cda59"]])

export default __exports__